import classnames from 'classnames';
import { func, number } from 'prop-types';
import React from 'react';
import { Col, Label, Row } from 'reactstrap';

import CurrencyFormat from '../../generic/CurrencyFormat';
import CurrencyInput from '../../generic/CurrencyInput';
import Input from '../../generic/Input';
import InfoTooltip from '../../generic/Tooltip/InfoTooltip';
import { getProductMetaFieldName } from '../utils';

const costPerShootingDayText = 'Incl. 1 model if applicable';

function renderCreativeBudgetLabel(
  label,
  name,
  index,
  width = 2,
  className,
  tooltip,
  tooltipText,
) {
  return (
    <Label
      sm={width}
      for={getProductMetaFieldName(index, name)}
      className={classnames('c-campaign-line__label', className)}
    >
      {label}
      {tooltip && (
        <span className="ml-1">
          <InfoTooltip target="creative-budget-label">
            {tooltipText}
          </InfoTooltip>
        </span>
      )}
    </Label>
  );
}

function renderCreativeBudgetValue(
  onChange,
  name,
  index,
  field,
  width = 2,
  plusSign = true,
) {
  return (
    <Col sm={width}>
      <CurrencyInput
        name={getProductMetaFieldName(index, name)}
        className="d-inline form-control p-0 pl-2 h-auto"
        value={field}
        style={{ width: '70px' }}
        onChange={onChange}
      />
      {plusSign && <span className="d-inline pl-4">+</span>}
    </Col>
  );
}

function CreativeEnhancedProductShootingBudgetBreakdown({
  onChange,
  index,
  costPerShootingDay,
  additionalModelCost,
  videoUpgrade,
  locationUpgrade,
  advancedUsageRights,
  numberOfShootingDays,
}) {
  return (
    <>
      <Row style={{ 'margin-top': '1rem' }}>
        <Col sm={3} />
        <Label sm={2} for="spendableBudget" className="c-campaign-line__label">
          Spendable Budget
        </Label>
        <Col sm={7}>
          <Row>
            {renderCreativeBudgetLabel(
              'Cost per shooting day',
              'costPerShootingDay',
              index,
              2,
              null,
              true,
              costPerShootingDayText,
            )}
            {renderCreativeBudgetLabel(
              'Additional model cost',
              'additionalModelCost',
              index,
            )}
            {renderCreativeBudgetLabel('Video upgrade', 'videoUpgrade', index)}
            {renderCreativeBudgetLabel(
              'Location upgrade',
              'locationUpgrade',
              index,
            )}
            {renderCreativeBudgetLabel(
              'Advanced usage rights',
              'advancedUsageRights',
              index,
            )}
          </Row>
        </Col>
      </Row>

      <Row className="align-items-baseline" style={{ 'margin-top': '-0.4rem' }}>
        <Col sm={3} />
        <Col sm={1}>
          <CurrencyFormat
            value={
              costPerShootingDay +
              additionalModelCost +
              videoUpgrade +
              locationUpgrade +
              advancedUsageRights
            }
            name="spendableBudget"
            text
          />
        </Col>
        <Col sm={1} className="c-campaign-line__label pl-5">
          =
        </Col>
        <Col sm={7}>
          <Row>
            {renderCreativeBudgetValue(
              onChange,
              'costPerShootingDay',
              index,
              costPerShootingDay,
            )}
            {renderCreativeBudgetValue(
              onChange,
              'additionalModelCost',
              index,
              additionalModelCost,
            )}
            {renderCreativeBudgetValue(
              onChange,
              'videoUpgrade',
              index,
              videoUpgrade,
            )}
            {renderCreativeBudgetValue(
              onChange,
              'locationUpgrade',
              index,
              locationUpgrade,
            )}
            {renderCreativeBudgetValue(
              onChange,
              'advancedUsageRights',
              index,
              advancedUsageRights,
              1,
              false,
            )}
          </Row>
        </Col>
      </Row>

      <Row style={{ 'margin-top': '1rem' }}>
        <Col sm={3} />
        <Label
          sm={2}
          for="numberOfShootingDays"
          className="c-campaign-line__label"
        >
          Number of Shooting Days
        </Label>
        <Col sm={7}>
          <Row>
            <Col sm={2}>
              <Input
                name={getProductMetaFieldName(index, 'numberOfShootingDays')}
                type="number"
                className="d-inline form-control p-0 pl-2 h-auto"
                value={numberOfShootingDays}
                style={{ width: '110px' }}
                onChange={onChange}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

CreativeEnhancedProductShootingBudgetBreakdown.propTypes = {
  index: number.isRequired,
  costPerShootingDay: number.isRequired,
  additionalModelCost: number.isRequired,
  videoUpgrade: number.isRequired,
  locationUpgrade: number.isRequired,
  advancedUsageRights: number.isRequired,
  numberOfShootingDays: number.isRequired,
  onChange: func.isRequired,
};

export default CreativeEnhancedProductShootingBudgetBreakdown;
